import { Injectable, inject, signal } from '@angular/core'
import { FormControl, FormGroup } from '@angular/forms'
import {
  GetPaginatedLocationsGroupsGQL,
  GetPaginatedLocationsGroupsQuery,
  LocationGroupOrderByInput,
  PageInfo
} from '@generated/sammathnaur.graphql'
import { Subject, firstValueFrom } from 'rxjs'
import type { Apollo } from 'apollo-angular'

@Injectable({
  providedIn: 'root',
})
export class LocationGroupsService {
  public search$: Subject<void> = new Subject()
  public readonly filterForm = new FormGroup({
    name_contains: new FormControl(),
    archived: new FormControl(false as 'all' | false | true),
  })

  public orderBy = signal<LocationGroupOrderByInput>(LocationGroupOrderByInput.NameAsc)
  public limit = signal<number>(25)
  public offset = signal<number>(0)
  public totalCount = signal<number>(0)
  public isLoading = signal<boolean>(false)
  public pageInfo = signal<PageInfo | undefined>(undefined)
  public shouldUpdateOptions$ = new Subject<void>()
  public getPaginatedLocationsGroupsGQL = inject(GetPaginatedLocationsGroupsGQL)

  public async searchPage(): Promise<Apollo.QueryResult<GetPaginatedLocationsGroupsQuery>> {
    const { name_contains, archived } = this.filterForm.value

    const observable$ = this.getPaginatedLocationsGroupsGQL.fetch({
      variables: {
        where: {
          name_contains,
          archived: archived === 'all' ? undefined : archived,
        },
        limit: this.limit(),
        offset: this.offset(),
        orderBy: this.orderBy(),
      },
    })

    return firstValueFrom(observable$)
  }
}
